import { defineComponent as c, computed as s, createElementBlock as f, openBlock as p, mergeProps as l, unref as t, createElementVNode as d, toDisplayString as u } from "vue";
import r from "../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Skeleton/skeleton.js";
import { c_skeleton_Height as h } from "../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_skeleton_Height.js";
import { c_skeleton_Width as S } from "../node_modules/.pnpm/@patternfly_react-tokens@6.2.2/node_modules/@patternfly/react-tokens/dist/esm/c_skeleton_Width.js";
import { useOUIAProps as _ } from "../helpers/ouia.js";
const k = { class: "pf-v6-screen-reader" }, I = /* @__PURE__ */ c({
  name: "PfSkeleton",
  __name: "Skeleton",
  props: {
    width: {},
    height: {},
    fontSize: {},
    shape: {},
    screenreaderText: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(i) {
    const e = i, n = _({ id: e.ouiaId, safe: e.ouiaSafe }), a = s(() => e.fontSize ? Object.values(r.modifiers).find((o) => o === `pf-m-text-${e.fontSize}`) : void 0), m = s(() => ({
      [S.name]: e.width,
      [h.name]: e.height
    }));
    return (o, g) => (p(), f("div", l(t(n), {
      class: [t(r).skeleton, {
        [a.value ?? t(r).modifiers.circle]: o.fontSize,
        [t(r).modifiers.circle]: o.shape === "circle",
        [t(r).modifiers.square]: o.shape === "square"
      }],
      style: m.value
    }), [
      d("span", k, u(o.screenreaderText), 1)
    ], 16));
  }
});
export {
  I as default
};
